import { Flex } from '@chakra-ui/react';
import useSystemPartnerQuery from 'hooks/useSystemPartnerQuery';
import useWorkshopQuery from 'hooks/useWorkshopQuery';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentCard } from '../../../layout/ContentCard';
import { AbortDeletion } from './AbortDeletion';
import { EndContract } from './EndContract';
import { HardDelete } from './HardDelete';
import { LockWorkshop } from './LockWorkshop';
import { SoftDelete } from './SoftDelete';
import { UnlinkSystempartner } from './UnlinkSystempartner';

const DangerZoneCard = ({ workshopId }: { workshopId: number }) => {
  const { t } = useTranslation();
  const workshopQuery = useWorkshopQuery(workshopId);
  const systemPartnerQuery = useSystemPartnerQuery();
  const isStatusPendingDeletion = workshopQuery.data?.status === 950;

  const systemPartnersOfWorkshop = useMemo(() => {
    if (workshopQuery.isPending || systemPartnerQuery.isPending) {
      return [];
    }
    const systemPartnerIdsOfWorkshop =
      workshopQuery.data?.users
        .filter((user) => user.type === 'systempartner')
        .map((user) => user.systempartner_id)
        .filter((id) => id != null) ?? [];
    return systemPartnerQuery.data?.filter((systemPartner) => systemPartnerIdsOfWorkshop.includes(systemPartner.id)) ?? [];
  }, [systemPartnerQuery.data, systemPartnerQuery.isPending, workshopQuery.data?.users, workshopQuery.isPending]);

  return (
    <ContentCard
      minH="fit-content"
      header={t('workshop:danger_zone.title')}
      contentDescription={t('workshop:danger_zone.description')}
      isLoading={workshopQuery.isPending}
      bgColor="red.100"
      dividerBorderColor="red.50"
    >
      <Flex direction={'column'} gap={6}>
        <LockWorkshop workshopId={workshopId} />
        <EndContract workshopId={workshopId} />
        <UnlinkSystempartner workshopId={workshopId} systemPartnersOfWorkshop={systemPartnersOfWorkshop} />
        <SoftDelete workshopId={workshopId} systemPartnersOfWorkshop={systemPartnersOfWorkshop} />
        <HardDelete workshopId={workshopId} systemPartnersOfWorkshop={systemPartnersOfWorkshop} />
        {isStatusPendingDeletion && <AbortDeletion workshopId={workshopId} />}
      </Flex>
    </ContentCard>
  );
};

export default DangerZoneCard;
